<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter1" id="frontis">
<img alt="" class="w" id="id-3842049634609581488" src="Images/img0001.jpg"/>
<div class="caption"><p class="center">THEY BEHELD A HUT OF DRIFTWOOD AND PALM LEAVES.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?281124e5